/* Publish by EComposer at 2024-07-23 03:12:09*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4fjoqcv4orn"]=  window.__ectimmers["ecom-4fjoqcv4orn"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-4fjoqcv4orn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fjoqcv4orn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6bukeqkih2t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bukeqkih2t', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ge3i43id9di').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ge3i43id9di', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-88m77ljqypo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-88m77ljqypo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6gw41coklns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6gw41coklns', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9h1h9w19fha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9h1h9w19fha', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0cuda05m5q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0cuda05m5q', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gf7r2jbxor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gf7r2jbxor', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}